import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import * as passwordAction from "../../actions/passwordActions";
import { routes } from "../../constants/routes";

/**
 * Komponent do akcji zapomniałem hasło. Zawiera formularz z emailem do wpisania. 
 * Zatwierdzenie akcji powoduje przekierowania na stronę główą aplikacji wraz z wyświetleniem informacji (toast), że 
 * na podany email został wysłany link, za pomocą którego można zmienić hasło.
 */
class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {
                email: "",
            }
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onForgotPassword(this.state.user);
    };

    handleInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        let user = { ...this.state.user, [name]: value };
        this.setState({ user });
    };

    render() {

        return (

            <div className="w3-display-container" style={{ height: "100vh" }}>

                <div className="w3-display-middle">

                    <div className="w3-container">

                        <div className="w3-card-4" style={{ width: "40vw" }}>

                            <div className="w3-container w3-theme-dark w3-center">
                                <h2><FormattedMessage
                                    id="app.forgotPasswordPage.title"
                                    defaultMessage="Forgot password"
                                /></h2>
                            </div>

                            <div className="w3-container">

                                <p>
                                    <FormattedMessage
                                        id="app.forgotPasswordPage.description"
                                        defaultMessage="Enter the email address associated with your account and we'll send you a password change link."
                                    />
                                </p>

                                <form
                                    className="w3-container w3-padding"
                                    onSubmit={this.handleSubmit}
                                >
                                    <div className="w3-row-padding">
                                        <input
                                            className="w3-input"
                                            type="text"
                                            name="email"
                                            onChange={this.handleInputChange}
                                            value={this.state.user.email}
                                            required
                                        />
                                        <label className="w3-text-theme w3-small">
                                            <FormattedMessage id="user.email" defaultMessage="E-mail" />
                                        </label>
                                    </div>

                                    <div className="w3-bar">
                                        <button
                                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                                            type="submit"
                                        >
                                            <FormattedMessage
                                                id="app.forgotPasswordPage.action.submit"
                                                defaultMessage="E-mail"
                                            />
                                        </button>
                                    </div>
                                </form>

                            </div>

                            <footer className="w3-container w3-theme-dark">
                                <div className="w3-bar">
                                    <Link to={routes.LOGIN} className="w3-bar-item w3-left w3-small w3-btn" > &lt; Powrót do logowania</Link>
                                </div>
                            </footer>

                        </div>

                    </div>

                </div>

            </div>

        )

    }

}

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onForgotPassword: (user, callback) => {
            dispatch(passwordAction.doForgotPassword(user, callback));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword);